import { Navigate, useParams } from 'react-router-dom'

import { paths } from 'src/router'

import type { AppDetailSection } from '../utils/appDetailNav'

type Props = {
  section: AppDetailSection
}

/**
 * Maps old `/apps/:appId/<section>` URLs onto `?section=` on the canonical app
 * detail route (decision B). The detail page navigates via a sidebar now, so
 * every former tab is a flat section id.
 */
export const WorkspaceAppLegacyTabRedirect = ({ section }: Props) => {
  const { id = '', appId = '' } = useParams<{ id: string; appId: string }>()

  if (!id || !appId) {
    return <Navigate to={paths.workspaces.root} replace />
  }

  return (
    <Navigate
      to={{
        pathname: paths.workspaces.apps.details(id, appId),
        search: `?section=${section}`
      }}
      replace
    />
  )
}
